import React from 'react';
import { ThemeProvider } from 'styled-components';
import { ShAuthTokenProvider } from './contexts/shAuthContext';
import { GlobalStyle } from './themes/global';
import { theme } from './themes/theme';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import SatfarmRoutes from './SatfarmRoutes';
import { setAmAuthTokenOnAxiosInstance } from './config/axios';
import LanguageProvider from './contexts/LanguageContext';

import '@area-monitoring/react-components/style/all.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ReactKeycloakProvider
        initOptions={{
          pkceMethod: 'S256',
          checkLoginIframe: false,
        }}
        authClient={keycloak}
        onTokens={(event) => {
          if (event.token) {
            setAmAuthTokenOnAxiosInstance(event.token);
          }
        }}
      >
        <ShAuthTokenProvider>
          <LanguageProvider>
            <GlobalStyle />
            <SatfarmRoutes />
          </LanguageProvider>
        </ShAuthTokenProvider>
      </ReactKeycloakProvider>
    </ThemeProvider>
  );
}

export default App;
